// src/pages/EnergyAnalysis.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EnergyYearComparison from '../components/EnergyYearComparison';
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import CustomModal from '../components/CustomModal';
import '../css/Energie.css';
import '../css/EnergyAnalysis.css';

const EnergyAnalysis = () => {
  const navigate = useNavigate();
  const [predictionComparison, setPredictionComparison] = useState([]);
  const [showPredictionModal, setShowPredictionModal] = useState(false);

  return (
    <div className="beheer-wrapper">
      <BeheerdersportaalSidebar>
        <main className="dashboard">
          <div className="page-header">
            <div className="header-navigation">
              <button 
                className="back-button"
                onClick={() => navigate('/energie')}
              >
                Back to Energy Dashboard
              </button>
            </div>
            <h1>🔍 Energy Analysis</h1>
            <p>Detailed energy usage analysis and comparison tools</p>
          </div>

          <div className="energy-analysis-container">
            {/* Main Energy Comparison Component */}
            <div className="analysis-section">

              <div className="card">
                <EnergyYearComparison setPredictionComparison={setPredictionComparison} />
              </div>
            </div>

            {/* Additional Analysis Tools */}
            <div className="analysis-tools">
              <div className="card">
                <h3>🔍 Prediction Analysis</h3>
                <p>Compare predicted vs. actual usage across all apartments</p>
                <button
                  className="button"
                  onClick={() => setShowPredictionModal(true)}
                >
                  View Prediction Comparison
                </button>
              </div>

              <div className="card">
                <h3>📈 Trends & Patterns</h3>
                <p>Analyze usage patterns and identify anomalies</p>
                <button 
                  className="button" 
                  onClick={() => navigate('/degree-days')}
                >
                  View Temperature Analysis
                </button>
              </div>

              <div className="card">
                <h3>⚙️ Admin Tools</h3>
                <p>Advanced management and data import tools</p>
                <button 
                  className="button" 
                  onClick={() => navigate('/ista-admin')}
                >
                  ISTA Admin Panel
                </button>
              </div>
            </div>
          </div>

          {/* Prediction Modal */}
          <CustomModal 
            isOpen={showPredictionModal} 
            onClose={() => setShowPredictionModal(false)}
          >
            <div className="prediction-modal">
              <div className="modal-title">📊 Prediction vs Previous Year</div>
              <div className="sticky-table-container">
                <table className="sticky-header-table">
                  <thead>
                    <tr>
                      <th>🏠 Apartment</th>
                      <th>Predicted</th>
                      <th>Previous Year</th>
                      <th>Difference</th>
                      <th>% Change</th>
                    </tr>
                  </thead>
                </table>
                
                <div className="table-scroll-container">
                  <table className="content-table">
                    <tbody>
                      {predictionComparison.map((row, i) => {
                        const percent = row.percent === 'N/A' ? null : parseFloat(row.percent);
                        const highlight = percent !== null && Math.abs(percent) > 15;
                        return (
                          <tr
                            key={i}
                            style={{
                              backgroundColor: highlight
                                ? percent > 0 ? '#ffe5e5' : '#e5ffe5'
                                : 'transparent',
                            }}
                          >
                            <td>{row.homeNumber}</td>
                            <td>{row.predicted}</td>
                            <td>{row.previous}</td>
                            <td className={row.diff > 0 ? 'text-red-600' : 'text-green-600'}>
                              {row.diff}
                            </td>
                            <td>{row.percent}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </CustomModal>
        </main>
      </BeheerdersportaalSidebar>
    </div>
  );
};

export default EnergyAnalysis;